
// Link to the backend database

export const API_URL = "https://banana-pudding-11491.herokuapp.com/api/products/";
